import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../public/css/styles.css'

//import '../public/css/icon.css'
import './assets/css/variables.css';

/**
 * Agregamos la URL base de nuestra API. Para conectarse al backend local:
 */
//axios.defaults.baseURL = process.env.VUE_APP_API_URL
//const ipBackend = '192.168.1.9'
//const puertoBackend = '5000'
const isPRD = process.env.VUE_APP_ENV === 'PRD'
const urlAPILocal = `http://${process.env.VUE_APP_API_URL_LOCAL}:${process.env.VUE_APP_API_PORT}`

const urlAPI = isPRD ? '/api' : urlAPILocal

axios.defaults.baseURL = urlAPI
axios.defaults.withCredentials = !isPRD
//axios.defaults.withCredentials = true;


/* Configurar un interceptor para agregar el token en cada solicitud
axios.interceptors.request.use((config) => {
  const usuario = localStorage.getItem('usuario');
  if (usuario) {
    const token = JSON.parse(usuario).token;  // Ajusta según cómo esté almacenado el token
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
*/

// Configurar un interceptor para agregar el API KEY en cada solicitud
axios.interceptors.request.use((config) => {
  config.headers["x-api-key"] = Constantes.API_KEY;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Configurar un interceptor para manejar respuestas
axios.interceptors.response.use((response) => {
  // Si la respuesta es exitosa, simplemente retornamos la respuesta
  return response;
}, (error) => {
  console.log(error)
  if (!error.response) {
    console.error('Error de red o servidor no disponible:', error)
    return Promise.reject(error)
  }
  // Verificar si la respuesta tiene un estado 401, 403, 429
  if (error.response.status === Constantes.HTTP.ACCESO_NO_AUTORIZADO.CODIGO
    || error.response.status === Constantes.HTTP.ACCESO_DENEGADO.CODIGO
    || error.response.status === Constantes.HTTP.ERROR_MUCHAS_PETICIONES.CODIGO) {
    // Redirigir a una ruta específica, por ejemplo, una página de login o acceso denegado
    let accion = error.response.data.accion
    switch (accion) {
      case Constantes.ACCIONES_FRONTEND_HTTP_403.VOLVER_INICIAR_SESION:
        volverIniciarSesion()
        break
      case Constantes.ACCIONES_FRONTEND_HTTP_403.SOLO_MOSTRAR_MENSAJE:
        break
      case Constantes.ACCIONES_FRONTEND_HTTP_403.VER_PAGINA_MUCHAS_PETICIONES:
        localStorage.setItem('vpmp',"true")
        localStorage.setItem("vpmp_expire", Date.now() + error.response.data.windowMs);
        location.href = '/429'
        break
      default:
        //location.href = '/403'
        break
    }
  }
  return Promise.reject(error);
});

function volverIniciarSesion() {
  localStorage.clear()
  location.href = '/'
}
/**
 * Agregamos la URL base de nuestra API. Para conectarse al backend de producción heroku:
 */
//axios.defaults.baseURL = 'https://somarufps.herokuapp.com';


import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { Constantes } from './util/Constantes'

const vuetify = createVuetify({
  components,
  directives
})

const app = createApp(App)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(vuetify)

app.mount('#app')
